import { useToast } from '@apex/component-library'
import { useCallback } from 'react'

export const useToastErrorHandler = () => {
  const toast = useToast()
  const toastMemo = useCallback(toast, [])
  return useCallback(
    (error: string) => {
      toastMemo({
        title: 'Error!',
        description: error,
        status: 'error',
        isClosable: true,
        duration: null,
      })
    },
    [toastMemo]
  )
}
